import { Card } from "@/core/components/ui/card";
import { Separator } from "@/core/components/ui/separator";
import { Stack } from "@/core/components/ui/stack";
import { useGetBusinessStats } from "@/business/query";
import { useBusiness } from "@/core/business";
import { cn } from "@/core/utils/utils";
import { AdvocateAndReferralCounters } from "./advocate-and-referral-counters";
import { SignupLeaderboard } from "./signup-leaderboard";

interface ReferralStatsProps {
  className?: string;
}

export const ReferralStats = ({ className }: ReferralStatsProps) => {
  const { businessId } = useBusiness();
  const { data: businessStats } = useGetBusinessStats(businessId);

  if (!businessId) return null; // preloaded at app level

  return (
    <Card
      data-cy="referral-stats"
      className={cn(
        "flex h-[calc(100vh-158px)] min-w-[266px] max-w-[266px] flex-1 flex-col p-4 pb-0 pr-0",
        className,
      )}
    >
      <Stack gap="lg" className="flex-1 overflow-hidden" fullWidth>
        <AdvocateAndReferralCounters
          className="flex-none pr-4"
          direction="column"
          advocates={businessStats?.program_signup_count}
          referrals={businessStats?.referral_count}
        />
        <Separator orientation="horizontal" className="w-[calc(100%-16px)]" />
        <SignupLeaderboard
          className="flex-1 overflow-hidden"
          businessId={businessId}
        />
      </Stack>
    </Card>
  );
};
